import React from 'react';
import moment, { Moment } from 'moment';
import { DatePicker } from 'syngenta-digital-cropwise-react-ui-kit';
import { useField } from 'formik';

type DateTimeFieldProps = {
  name: string;
  id?: string;
};

/** A kit date + time picker bound to a Formik field that stores a `Date`. */
const DateTimeField = ({ name, id = name }: DateTimeFieldProps) => {
  const [{ value }, , { setValue, setTouched }] = useField<
    Date | string | null
  >(name);

  return (
    <DatePicker
      id={id}
      className="w-full"
      showTime={{ format: 'h:mm A', use12Hours: true }}
      format="MMM D, YYYY h:mm A"
      value={value ? moment(value) : null}
      onBlur={() => setTouched(true)}
      onChange={(date: Moment | null) => {
        setTouched(true, false);
        setValue(date ? date.toDate() : null);
      }}
    />
  );
};

export default DateTimeField;
